module.exports = __webpack_public_path__ + "img/fb.74cc5893.svg";